import DropDown from "../../Components/DropDown/DropDown";
import { useTranslation } from 'react-i18next';

const Download = (props:any) => {
	const { t } = useTranslation();
	const options = [
		{ value: 'csv', label: 'CSV' },
		{ value: 'pdf', label: 'PDF' },
		{ value: 'xlsx', label: 'Excel' },
		{ value: 'html', label: 'HTML' }
	]

	const arrowClosed = (
		<span className="arrow-closed" />
	)

	const arrowOpen = (
		<span className="arrow-open" />
	)

	return <DropDown
		arrowClosed={arrowClosed}
		arrowOpen={arrowOpen}
		options={options}
		value={t('download')}
		onChange={props.onChange}
	/>;
}

export default Download;
